export default "__VITE_ASSET__72ce2757__"